import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { LockIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 px-4 text-center" data-id="element-53">
      <div className="max-w-xl mx-auto" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-55">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-charcoal mb-3" data-id="element-56">
            Ihr nächstes Semester beginnt heute.
          </h2>
          <p className="text-[15px] sm:text-base text-gray-700 mb-6 leading-relaxed" data-id="element-57">
            Jede Woche ohne dieses System ist eine Woche, die Sie unnötig
            Stunden investieren. Über 500 Schweizer Instruktoren und
            Lehrpersonen haben bereits entschieden.
            <br data-id="element-58" />
            <br data-id="element-59" />
            <span className="font-bold text-brand-charcoal" data-id="element-60">
              Jetzt sind Sie dran.
            </span>
          </p>

          <CTAButton href="#pricing" className="mb-3" data-id="element-61">
            ✅ JETZT SYSTEM WÄHLEN
          </CTAButton>

          <div className="text-[13px] sm:text-sm font-bold text-gray-600 mb-1.5" data-id="element-62">
            Basis CHF 19.90 · Experten CHF 23.90 · PDF Sofort-Download 🇨🇭
          </div>
          <div className="flex justify-center items-center gap-2 text-[11px] sm:text-xs text-gray-500" data-id="element-63">
            <LockIcon className="w-3 h-3" data-id="element-64" /> Sichere Zahlung · 7-Tage-Garantie ·
            Sofortiger Zugang
          </div>
        </motion.div>
      </div>
    </section>;
}